import '~/styles/css/App.css'

import React, { useReducer } from 'react'
import TasksList from '~/components/tasks/tasksList'
import taskContext from '~/contexts/tasks/tasksContext'
import taskReducer from '~/contexts/tasks/tasksReducer'
import AddTask from '~/components/tasks/addTask'

const App: React.FC = () => {
    const getTasks = () => {
        const localTasks = localStorage.getItem('tasks') || '[]'
        let tasks
        try {
            tasks = JSON.parse(localTasks)
        } catch (e) {
            tasks = []
        }
        return { tasks }
    }

    const [state, dispatch] = useReducer(taskReducer, { tasks: [] }, getTasks)

    return (
        <div className="App">
            <header>
                <h1>Mes tâches</h1>
            </header>
            <hr />
            <taskContext.Provider value={{ state, dispatch }}>
                <TasksList />
                <AddTask />
            </taskContext.Provider>
        </div>
    )
}

export default App
